// import SoopNavigation from '@front-end/soop-navigation/dist/ui-navigation-esm';

import globalDomains from './global-domains';
import {getUserLoginId} from './main';

/*
 * SoopNavigation을 글로벌로 연동하기 위한 래퍼 객체
 * */
const GlobalNavigation = () => {
  let navigationCore = null;

  const initializeNavigation = ($gnb, $snb, $fnb, options = {}) => {
    if (typeof window !== 'undefined') {
      // 빌드 시점에 soop-navigation이 참조하는 window 객체에 접근해서 진상 부리며 빌드를 안해주기 때문에
      // 아래와 같이 처리
      // process.env.BUILD_ENV === 'develop'

      const STAGE_ALIAS = {
        develop: '',
        release: 'release',
        'release-beta': 'release-beta',
        main: 'production',
      };

      const SoopNavigation = require(
        `@front-end/soop-navigation/dist/ui-navigation-esm${(STAGE_ALIAS[process.env.BUILD_ENV] ? '.' : '') + STAGE_ALIAS[process.env.BUILD_ENV]}`,
      ).default;
      // require('/Users/hslee/WebstormProjects/soop-navigation/dist/ui-navigation-esm.js').default;
      navigationCore = SoopNavigation($gnb, $snb, $fnb, {
        shouldShowHamburgerMenu: !!$snb,
        shouldShowAdvertise: true,
        ad: {
          loadsCustomizable: false,
          visibility: {
            hasCollaboAd: true,
            hasSearchBarAd: true,
            hasSnbMenuAd: true,
            hasKeywordAd: true,
          },
        },
        ...options,
      });
    }
  };
  return {
    getNavigationInstance() {
      return navigationCore;
    },
    init($gnb, $snb, $fnb, options = {}) {
      /*if (typeof window !== undefined) {
        navigationCore = SoopNavigation($gnb, $snb, $fnb, {
          shouldShowHamburgerMenu: true,
        });
      }*/

      initializeNavigation($gnb, $snb, $fnb, options);
    },
    refresh() {
      if (navigationCore) {
        navigationCore.reload();
      }
    },
    handleAuthorized(callback) {
      if (navigationCore) {
        navigationCore.handleAuthorized((userInfo, soopiTicket) => {
          callback(userInfo, soopiTicket);
        });
      }
    },
    handleInternalRouteChange(callback) {
      if (navigationCore) {
        navigationCore.handleInternalRouteChange((path) => {
          callback(path);
        });
      }
    },
    handleNewAdChecked(callback) {
      if (navigationCore) {
        navigationCore.handleNewAdChecked((adInfo) => {
          callback(adInfo);
        });
      }
    },
    handleThemeChanged(callback) {
      if (navigationCore) {
        navigationCore.handleThemeChanged((themeInfo) => {
          callback(themeInfo);
        });
      }
    },
    handleSoopiMenuToggle(callback) {
      if (navigationCore) {
        navigationCore.handleSoopiMenuToggle((isActive) => {
          callback(isActive);
        });
      }
    },
    handleDropDownMenuOpen(callback) {
      if (navigationCore) {
        navigationCore.handleDropDownMenuOpen((data) => {
          callback(data);
        });
      }
    },
    setSoopiToggle(isOpen) {
      if (navigationCore) {
        navigationCore.setSoopiToggle(isOpen);
      }
    },
    handlePopupRequest(callback) {
      if (navigationCore) {
        navigationCore.handlePopupRequest((type, data) => {
          callback(type, data);
        });
      }
    },
    setLayoutVisibility(layoutType, isVisible) {
      if (navigationCore) {
        navigationCore.setLayoutVisibility(layoutType, isVisible);
      }
    },
    setShowHamburgerMenu(isShow) {
      if (navigationCore) {
        navigationCore.showHamburgerMenu(isShow);
      }
    },
    setLogoSecondary(text, href) {
      if (navigationCore) {
        navigationCore.setLogoSecondary(text, href);
      }
    },
    setShowSearchBar(isShow) {
      if (navigationCore) {
        navigationCore.showSearchBar(isShow);
      }
    },
    setFooterCopyrightOnly(showsCopyrightOnly) {
      if (navigationCore) {
        navigationCore.setFooterCopyrightOnly(showsCopyrightOnly);
      }
    },
    getOption() {
      if (navigationCore) {
        return navigationCore.getOption();
      }
    },
    refreshProfileImages() {
      if (navigationCore) {
        const userId = getUserLoginId() || '';

        const refreshProfileImages = () => {
          const imageSelectors = [
            '.loginUserInfo .thumb img',
            '.userInfo .thumb img',
          ];
          const imageElements = document.querySelectorAll(
            imageSelectors.join(', '),
          );

          // 현재 시간으로 타임스탬프 생성
          const timestamp = new Date().getTime().toString();

          imageElements.forEach((element) => {
            // 타입 가드: HTMLImageElement 확인, src 값 확인
            if (element instanceof HTMLImageElement && element.src) {
              try {
                const url = `${globalDomains.PROFILE_IMG_AFREECATV}/LOGO/${userId.substring(0, 2)}/${userId}/m/${userId}.webp?_v=${timestamp}`;

                element.src = url.toString();
              } catch (error) {
                // 유효하지 않은 URL 형식일 경우 에러 처리
                console.error(
                  'Failed to update image src:',
                  element.src,
                  error,
                );
              }
            }
          });
        };

        return refreshProfileImages();
      }
    },
    handleMenuClickedOnce(callback) {
      if (navigationCore) {
        navigationCore.handleMenuClickedOnce((menuInfo, type) => {
          callback(menuInfo, type);
        });
      }
    },

    /**
     * 클릭 로그 데이터 오버라이드 설정
     * @param {Object} overrideData - send_data 내의 오버라이드할 데이터
     * @param {Object} topLevelData - send_data 밖의 최상위 레벨 데이터
     */
    setClickLogOverride(overrideData, topLevelData) {
      if (navigationCore) {
        navigationCore.setClickLogOverride(overrideData, topLevelData);
      }
    },

    /**
     * 특정 키의 오버라이드 데이터 제거
     * @param {string} [key] - 제거할 키 (없을 시 오버라이드 한 데이터 전부 삭제)
     * @param {boolean} [isTopLevel] - 최상위 레벨 데이터인지 여부
     */
    removeClickLogOverride(key, isTopLevel) {
      if (navigationCore) {
        navigationCore.removeClickLogOverride(key, isTopLevel);
      }
    },

    /**
     * 꽃가루 호출
     * @param {number} duration 노출 시간(기본값 5000ms)
     */
    fireConfetti(duration = 5000) {
      if (navigationCore) {
        navigationCore.fireConfetti(duration);
      }
    },
    getIPNation() {
      if (navigationCore) {
        return navigationCore.getIPNation();
      }
      return Promise.resolve(undefined);
    },
  };
};
const globalNavigation = GlobalNavigation();

export default globalNavigation;
